import React from 'react'
import Content from './Content'
const Room = () => {
  return (
    
      <div className="container mx-auto z-10 text-center">
            <Content isColor={true} title="ROOM & SUITES"
            subtitle="Exceptional Comfort And Spectacular Surroundings"
            />
          </div>
  )
}

export default Room